<template>
    <div class="login-index">
        <!-- <a-spin :spinning="spinning" class="spin-box" :tip="$t('spin.text')"> -->
            <div class='login-box'  :style="bgStyle">
                <img class="logo"  v-if="!isHiddenLoginInfo" :src="allData.companyLogoBase64 ? 'data:image/png;base64,'+allData.companyLogoBase64 : null" alt="">
                <div class="box">
                    <v-container class="pa-0" fluid fill-height>
                        <v-row no-gutters class="h-full">
                            <v-col
                                class=" d-flex flex-column align-center login-box-style"
                                :style="boxAbsolute"
                            >
                                <VBinding v-if="isType =='binding'" :bindingToken="bindingToken" @bindPwd="constraintPwd" @bindingFun="loginSuccess" @authMfaFunc="authMfaFunc"></VBinding>
                                <div :class="{'right-box':true,'auth-maf-content':isHiddenLoginInfo}" v-else>
                                    <div class="box-title" 　v-if="!isHiddenLoginInfo">{{uuid ? $t('login.idenAuth') : $t('login.cloundBind')}}</div>
                                    <!-- 登录界面 -->
                                    <div class="pwd-box" v-if="!isScanLogin">
                                        <v-form
                                          @submit.native.prevent
                                            v-if="!isHiddenLoginInfo && !isAuthUserName"
                                            class="form-box mb-5"
                                            ref="ruleForm">
                                            <v-text-field
                                                v-model="formData.username"
                                                outlined
                                                hide-details="auto"
                                                required
                                                class="input-h-md"
                                                color="#5066e0"
                                                :rules="rules1"
                                                :disabled="isLogin"
                                                :placeholder="$t('login.usernamePlaceholder')"
                                                @keydown="keydown"
                                            ></v-text-field>
                                        </v-form>

                                        <!-- 认证用户名成功界面 -->
                                        <div v-if="isAuthUserName">
                                            <!-- step 1. 列出当前用户要认证的策略　-->
                                            <div class="more-title">
                                                <img src="@/assets/img/text-left.png" alt="">
                                                <span>{{$t('login.authenticationMethodss')}}</span>
                                                <img src="@/assets/img/text-right.png" alt="">
                                            </div>
                                            <div class="more-box" v-if="authenticators.length > 0" :style="{textAlign: authenticators.length < 6 ? 'center' : 'left'}">
                                                <template v-for="(item, index) in authenticators" >
                                                    <v-tooltip top color="rgba(0, 0, 0, 0.75)">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <div class="img_box">
                                                                <img
                                                                    v-bind="attrs"
                                                                    v-on="on"
                                                                    class="img1_normal"
                                                                    @click="rowFun(item,index)"
                                                                    @mouseover="imgLarge(item.logoBase64,index)"
                                                                    @mouseleave="imgSmall(item.logoBase64,index)"
                                                                    :src="item.logoUrl?(require('@/assets/img/'+ item.logoUrl)):('data:image/png;base64,'+item.logoBase64)"
                                                                    alt=""
                                                                    :key="index"
                                                                />
                                                                <img v-bind="attrs" v-on="on" src="@/assets/img/Slice140.png" class="img_shadow_none" :style="{'display':(item.code == selectedMfaIndex ? 'block' : 'none')}" />
                                                                <!-- <img v-bind="attrs" v-on="on" src="@/assets/img/Slice140.png" class="img_shadow" :style="{'display': (item && index == 0 && !ThirdCode.includes(item.code)) ? 'block':'none'}"/> -->
                                                            </div>
                                                        </template>
                                                      <div>
                                                        <div class="ant-tooltip-content"><div class="ant-tooltip-arrow"></div><div role="tooltip" class="ant-tooltip-inner">  <span>{{item.name}}</span> </div></div>
                                                      </div>
                                                    </v-tooltip>
                                                </template>
                                            </div>
                                        </div>
                                        <!-- step 1.1 列出当前用户要认证的策略列表　-->
                                        <div v-if="isAuthUserName">
                                            <!-- 密码登录 -->
                                            <div class="fusb-Key pwd" v-if="(showFUSBKey && showFUSBKey == 'pwd') || (authenticators[0].key == 'pwd' && !showFUSBKey)">
                                                <v-text-field
                                                    v-model="password"
                                                    outlined
                                                    hide-details="auto"
                                                    required
                                                    color="#5066e0"
                                                    class="code-pwd input-h-md"
                                                    ref="pwd"
                                                    :title="$t('login.passwordPlaceholder')"
                                                    :type="isPasswordVisible1 ? 'text' : 'password'"
                                                    :append-icon="isPasswordVisible1 ? icons.mdiEyeOutline:icons.mdiEyeOffOutline"
                                                    @click:append="isPasswordVisible1 = !isPasswordVisible1"
                                                    :placeholder="$t('login.passwordPlaceholder')"
                                                    @keydown="keydown"
                                                ></v-text-field>
                                            </div>
                                            <!-- ldap登录 -->
                                            <div class="fusb-Key pwd" v-if="(showFUSBKey && showFUSBKey == 'ldap')  || (authenticators[0].key == 'ldap' && !showFUSBKey)">
                                                <v-text-field
                                                    v-model="password"
                                                    outlined
                                                    hide-details="auto"
                                                    required
                                                    color="#5066e0"
                                                    class="code-pwd input-h-md"
                                                    ref="ldap"
                                                    :title="$t('login.passwordPlaceholder')"
                                                    :type="isPasswordVisible1 ? 'text' : 'password'"
                                                    :append-icon="isPasswordVisible1 ? icons.mdiEyeOutline:icons.mdiEyeOffOutline"
                                                    @click:append="isPasswordVisible1 = !isPasswordVisible1"
                                                    :placeholder="$t('login.passwordPlaceholder')"
                                                    @keydown="keydown"
                                                ></v-text-field>
                                            </div>
                                            <!-- otp登录 -->
                                            <div class="fusb-Key" v-if="(showFUSBKey && showFUSBKey == 'otp') || (authenticators[0].key == 'otp' && !showFUSBKey)" key="otp">
                                                <v-row no-gutters>
                                                    <v-col cols="8">
                                                        <v-text-field
                                                            v-model="fUSBKeyData"
                                                            ref="otp"
                                                            :title="$t('login.otpPlaceholder')"
                                                            outlined
                                                            hide-details="auto"
                                                            required
                                                            color="#5066e0"
                                                            class="code-btn input-h-md"
                                                            @keydown="keydown"
                                                            :placeholder="$t('login.otpPlaceholder')"
                                                        ></v-text-field>
                                                    </v-col>

                                                    <v-col class="code-text  ml-3 d-flex justify-end align-baseline" :class="otpText == $t('push.text') ? 'cursor-pointer':'text'" @click="pushFun">
                                                        <v-btn outlined v-if="otpText == $t('push.text')" color="primary" min-height="50" style="width:100%">{{otpText}}</v-btn>
                                                        <v-btn outlined v-else style="width:100%" disabled min-height="50">{{otpText+'s'}}</v-btn>
                                                    </v-col>
                                                </v-row>
                                            </div>
                                            <!-- 短信验证码登录 -->
                                            <div class="fusb-Key phone-code" v-else-if="(showFUSBKey && showFUSBKey == 'phoneCode') || (authenticators[0].key == 'phoneCode' && !showFUSBKey)" key="phone-code">
                                                <v-row no-gutters>
                                                    <v-col cols="7">
                                                        <v-text-field
                                                            v-model="phoneCode"
                                                            ref="phoneCode"
                                                            :title="$t('code.phoneCodePlaceholder')"
                                                            outlined
                                                            hide-details="auto"
                                                            required
                                                            min-height="46"
                                                            color="#5066e0"
                                                            class="code-btn input-h-md"
                                                            @keydown="keydown"
                                                            :placeholder="$t('code.phoneCodePlaceholder')"
                                                        ></v-text-field>
                                                    </v-col>

                                                    <v-col class="code-text  ml-3 d-flex justify-end align-baseline" :class="codeText == $t('push.sendCode') ? 'cursor-pointer':'text'" @click="getPhoneCode">
                                                        <v-btn outlined v-if="codeText == $t('push.sendCode')" color="primary" min-height="50" style="width:100%">{{codeText}}</v-btn>
                                                        <v-btn outlined v-else style="width:100%" disabled min-height="50">{{codeText+'s'}}</v-btn>
                                                    </v-col>
                                                </v-row>
                                                <!-- <a-input class="code-btn" ref="phoneCode" :title="$t('code.phoneCodePlaceholder')" v-model="phoneCode"
                                                :placeholder="$t('code.phoneCodePlaceholder')"  @pressEnter="onSubmit">
                                                    <a-button class="code-text" type="link" :disabled="codeText == $t('push.sendCode') ? false : true"
                                                    @click="getPhoneCode" slot="addonAfter">{{codeText == $t('push.sendCode') ? $t('push.sendCode') : codeText+'s'}}</a-button>
                                                </a-input> -->
                                            </div>
                                            <!--邮箱验证码登录 -->
                                            <div class="fusb-Key phone-code" v-else-if="(showFUSBKey && showFUSBKey == 'email') || (authenticators[0].key == 'email' && !showFUSBKey)" key="email">
                                                <v-row no-gutters>
                                                    <v-col cols="7">
                                                        <v-text-field
                                                            v-model="emailCode"
                                                            ref="email"
                                                            :title="$t('code.emailCodePlaceholder')"
                                                            outlined
                                                            hide-details="auto"
                                                            required
                                                            color="#5066e0"
                                                            class="code-btn input-h-md"
                                                            @keydown="keydown"
                                                            :placeholder="$t('code.emailCodePlaceholder')"
                                                        ></v-text-field>
                                                    </v-col>

                                                    <v-col class="code-text  ml-3 d-flex justify-end align-baseline" :class="emailText == $t('push.sendCode') ? 'cursor-pointer':'text'" @click="getEmailCode">
                                                        <v-btn outlined v-if="emailText == $t('push.sendCode')" color="primary" min-height="50" style="width:100%">{{emailText}}</v-btn>
                                                        <v-btn outlined v-else style="width:100%" disabled min-height="50">{{emailText+'s'}}</v-btn>
                                                    </v-col>
                                                </v-row>
                                            </div>
                                            <!--择UAF指纹/人脸认证登录 -->
                                            <div class="fusb-Key fido-uaf fido-u2f" ref="fidoUaf" v-else-if="(showFUSBKey && showFUSBKey == 'fidoUaf')  || (authenticators[0].key == 'fidoUaf' && !showFUSBKey)" key="fidoUaf">
                                                {{$t('login.fidoUaf')}}
                                                <v-btn :disabled="uafText == $t('push.text') ? false : true" v-if="uafText != $t('push.text')" class="key-btn" color="primary">
                                                    {{uafText == $t('push.text') ? uafText : uafText+'s'}}
                                                </v-btn>
                                            </div>
                                            <!-- 临时认证口令 -->
                                            <div class="fusb-Key" v-else-if="(showFUSBKey && showFUSBKey == 'tempLogin') || (authenticators[0].key == 'tempLogin' && !showFUSBKey)" key="tempLogin">
                                                <v-text-field
                                                    v-model="tempLoginData"
                                                    ref="tempLogin"
                                                    outlined
                                                    hide-details="auto"
                                                    required
                                                    color="#5066e0"
                                                    class="code-btn input-h-md"
                                                    @keydown="keydown"
                                                    :placeholder="$t('login.tempLoginPlaceholder')"
                                                ></v-text-field>
                                            </div>
                                            <!--FIDO2认证登录 -->
                                            <div class="fusb-Key fido-u2f" ref="fidoU2f" v-else-if="(showFUSBKey && showFUSBKey == 'fidoU2f') || (authenticators[0].key == 'fidoU2f' && !showFUSBKey)" key="fidoU2f">
                                                {{$t('login.fidoU2f')}}
                                            </div>
                                            <!--FastPass 认证登录 -->
                                            <div class="fusb-Key fido-u2f" ref="fastLogin" v-else-if="(showFUSBKey && showFUSBKey == 'fastLogin')  || (authenticators[0].key == 'fastLogin' && !showFUSBKey)" key="fastLogin">
                                                {{$t('login.feiTianFastLogin')}}
                                            </div>
                                            <!--scanLogin 扫码登录 -->
                                            <div class="fusb-Key fido-u2f" ref="fastLogin" v-else-if="(showFUSBKey && showFUSBKey == 'scanLogin')  || (authenticators[0].key == 'scanLogin' && !showFUSBKey)" key="scanLogin">
                                                <!-- 扫码登录 -->
                                                <div class="scan-login-code-box">
                                                    <div class="code" ref="qrScanLoginCodeUrl"></div>
                                                    <div class="code-box_txt">{{$t('login.appLogin')}}</div>
                                                    <div class="stale-box" v-if="showStale">
                                                        <img class="stale-img" src="@/assets/img/stale.png" alt="">
                                                        <div class="qr-text">{{qrText}}</div>
                                                        <a src="javascript:;"   @click="getRefreshScanloginCode('refresh')">{{$t('login.clickRefresh')}}</a>
                                                    </div>
                                                    <div class="qr-success-text" v-if="qrCodeSuccess">
                                                        <img class="success-icon" src="@/assets/img/success-icon.png" alt="">
                                                        <div class="s-title">{{$t('login.scanSucc')}}</div>
                                                        <div>{{$t('login.confirmL')}}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <v-btn
                                                color="primary"
                                                :loading="loadingButton"
                                                min-height="50"
                                                v-if="showFUSBKey !='scanLogin'"
                                                class="login-btn"
                                                :disabled="showFUSBKey == 'fidoUaf' && uafText != $t('push.text')"
                                                @click="onSubmit">{{loginText}}
                                            </v-btn>
                                        </div>
                                    </div>
                                    <!-- 扫码登录 -->
                                    <div class="pwd-box code-box" v-else>
                                        <img src="@/assets/img/Slice132.png" class="code-box_bg"/>
                                        <div class="code" ref="qrCodeUrl"></div>
                                        <p class="code-box_txt">{{$t('login.appLogin')}}</p>
                                        <div class="stale-box" v-if="showFenceStale">
                                            <img class="stale-img" src="@/assets/img/stale.png" alt="">
                                            <div class="qr-text">{{qrFenceText}}</div>
                                            <a src="javascript:;"  v-if="isRefresh"  @click="getCode('refresh')">{{$t('login.clickRefresh')}}</a>
                                        </div>
                                    </div>

                                </div>

                            </v-col>

                        </v-row>
                    </v-container>
                  <VVerify   ref="verifyBox" :verification-object="verificationData"
                           @closeVerifyBox="closeVerifyBox"
                           @refreshFun="refreshVerify"
                           @successFun="multipleFuncAuth"
                           :captchaType="captchaType"></VVerify>
                </div>

            </div>
        <!-- </a-spin> -->
    </div>
</template>

<script>
import {
    loginAPI,
    reqLoginPwd,
    authLogin,
    ldapLogin,
    pushOtp,
    checkOtp,
    reGetQrcode,
    reqScanLogin,
    reqCheckFence,
    sendSms,
    phoneLogin,
    emailLogin,
    sendEmail,
    pushUaf,
    tempLogin,
    getLoginStatus,
    fido2AuthStart,
    fido2AuthConfirm,
    reqGetAuthenticators,
    reqFastLoginStart,
    reqFastLogin,
    reqRefreshLocationQrCode,
    redirectAuthSrcAuthorize,
    reqGet
} from "@/api/index";

import VBinding from './binding'

import QRCode from 'qrcodejs2'
import { base64urlEncode, base64urlDecode } from '@/utils/base64url-arraybuffer'
import {IsIPMode} from '@/utils/cookie'
import {platformType} from '@/utils/index'
import {setNavigationInfo} from '@/utils/serverUrl'


import VCarousels from './carousel'
import FingerprintJS from '@fingerprintjs/fingerprintjs'
import { mdiEyeOutline, mdiEyeOffOutline } from '@mdi/js';
import store from '@/store'
import VVerify from './verify'
import { IsPC } from '../../utils'

    export default {
        components: {
            VBinding,  VVerify, VCarousels
        },
        data() {
            return {
                formData: {},
                rules1: [
                    v => !!v || this.$t('login.usernameMsg')
                ],
                isLogin: false,
                allData: {
                    authSourceList: []
                },

                // authToken自动登录成功，bindingToken绑定，editPwd修改密码，retrieve手机号重置密码，retrieveEmail邮箱重置密码，subVisible子账号
                isType: '',
                isLdap: false,
                bindingToken: "",
                restsObj: {},
                captchaType: '',
                visible: false,
                noApp: false,
                multiFactor: [],
                fUSBKeyData: '',
                showFUSBKey: null,
                loginText: this.$t('login.sureConfirm'),
                spinning: true,
                loadingButton:false,
                codeImg: null,
                codeTimer: null,
                password:null,
                phoneCode: '',
                codeText: this.$t('push.sendCode'),
                emailCode: '',
                emailText: this.$t('push.sendCode'),
                sourceName: '',
                tempLoginData: '',
                otpText: this.$t('push.text'),
                uafText: this.$t('push.text'),
                otpInterval: null,
                uafInterval: null,
                fastPassInterval:null,
                editToken: "",
                showStale: false,
                isRefresh:false,
                qrCodeSuccess: false,
                qrText: this.$t('login.qrText'),
                showEditPwd: true,
                isHiddenLoginInfo:false, //隐藏图片界面
                isOpenPicAuth:false,
                isAuthUserName:false,
                onceAuth:false,
                reqId:null,
                uuid:null,
                authenticators:[],
                isScanLogin:false,
                selectAuthInfo:null,
                showFenceStale:false,
                qrFenceText:false,
                isPasswordVisible1: false,
                thirdCode:[331,332,333,334,335,336,339,340,341,342], //第三方Code
                selectedMfaIndex:'',
                icons: {
                    mdiEyeOutline,
                    mdiEyeOffOutline
                },
              verificationData:null,
              diy:{
                bg:require('@/assets/img/bg1.png'),
                opacity:0,
                type:1,
                bgColor:'#fffff',
                top:20,
                left:88,
              },

            };
        },
      computed:{

        bgStyle() {
          if(this.diy.type == 1){
            let opacity = this.diy.opacity>0?(this.diy.opacity/100):0
            return   {
              'background-image': 'linear-gradient(rgba(0, 0, 0, '+opacity+'), rgba(0, 0, 0, '+opacity+')),  url("'+this.diy.bg+'")',
              'background-repeat': 'no-repeat',
              'background-origin':' border-box',
              'background-position': 'left center',
              'background-size':'cover',
            }
          }

          return {
            'background-color':this.diy.bgColor,
          }
        },



        boxAbsolute(){

          let style = {
            "position": "absolute"
          }
          if(!this.diy.left && this.diy.left != 0) {
            this.diy.left = 88
          }
          let left = this.diy.left > 0?(100 - parseInt(this.diy.left))/100:1
          let b = `calc((100vw - 460px) * ${left}`
          style = {
            "position": "absolute",
            "top":this.diy.top + '%',
            "right":b
          }

          if(!IsPC()){
            style = {
              "position": "none",
              "margin-top": '30%',
              "margin-left":'auto',
              "margin-right":'auto',
            }
          }

          return style

        }

      },
        created() {
          this.$vuetify.theme.dark = false
            // 判断第三方是否登录成功 authToken=登录成功 bindToken=绑定
            if (window.location.href.indexOf("bindToken") > -1) {
                this.isType = 'binding'
                this.spinning = false
                this.bindingToken = window.location.href.match(/bindToken=(\S*)/)[1]
            } else if (window.location.href.indexOf("authToken") > -1) {
                this.spinning = false
                this.isType = 'authToken'
                this.goLogin()

            } else if (window.location.href.indexOf("errMsg") > -1) {
                let message = decodeURIComponent(window.location.href.match(/errMsg=(\S*)/)[1])
                store.dispatch('snackbar/openSnackbar',{
                    snackbarText: message,
                    colorType: 'error'
                })
                this.loginStatusFun()
            }  if (window.location.href.indexOf("bindToken") > -1) {
                this.spinning = false
            }
            else {
                this.isType = ''
                this.loginStatusFun()

            }
            // 获取密码规则
            // this.roluFun()

        },
        mounted() {

        },
        methods: {
            //获取当前访问状态
            loginStatusFun() {
                //如果是ip地址格式
                if(IsIPMode() && !this.$route.params.appKey) {
                    this.$router.push({
                        path: '/404'
                    })
                }
                getLoginStatus().then(res=> {
                    // 200，代表已登录，会返回"用户信息、token"等，跳转首页，或者跳转到页面路径上的redirectUrl
                    // 201，代表已登录，还需要验证多因素，会返回"多因素列表、appkey和企业logo"。验证多因素和之前那些接口一样处理
                    // 302，代表已登录，需要选择子账号后跳转应用，会返回"appkey，子账号列表"
                    // 401，代表未登录，会返回 原来getLoginApp的结果："appkey、企业logo、loginMode等"
                    // 404，代表应用不存在
                    if(res.data) {
                        setNavigationInfo(res.data)
                        if(res.data.loginStyle){
                          this.setLoginStyle(res.data.loginStyle)
                        }

                        this.spinning = false
                        this.allData = res.data
                        this.cookieAllFun(res.data, this.$GLOBA.StatusUnauthorized)
                        let redirectUrlPath = window.location.href.match(/redirectUrl=(\S*)/) ?window.location.href.match(/redirectUrl=(\S*)/)[1]:null
                        if(redirectUrlPath) {
                            let matchAllData =  decodeURIComponent(redirectUrlPath).match(/uuid=(\S*)/)
                            if(matchAllData && matchAllData.length > 1){
                                this.uuid = matchAllData[1]
                            }
                            if(this.uuid){
                                this.isAuthUserName = true
                                const fpPromise = FingerprintJS.load({
                                        monitoring: false
                                    })
                                ;(async () => {
                                    // Get the visitor identifier when you need it.
                                    const fp = await fpPromise
                                    const result = await fp.get()
                                    let params ={uuid:this.uuid,platform:platformType(),fingerprint:result.visitorId,fastLoginBind:true}
                                    this.authenticatorsUser(params)
                                })()
                            }

                        }
                    }else{
                        store.dispatch('snackbar/openSnackbar',{
                            snackbarText: res.message,
                            colorType: 'error'
                        })
                    }


                })
            },
            callApp(data){
                let encodeBase64URL =  Buffer.from(JSON.stringify(data),'utf-8').toString('base64').replace(/\+/g,'-').replace(/\//g,'_').replace(/\=+$/gi,'')
                window.location.href = "ft://"+ encodeBase64URL
                setTimeout(() => {
                    this.fastLogin()
                    this.spinning = false
                },1000)
                //定时调度
            },
            // 设置缓存
            cookieAllFun(val, code) {
                this.$cookieStore.setCookie('rsaKey', val.rsaPubKey)
            },
          //设置网站登录页面样式
          setLoginStyle(data){
            if(data){
              let style = Object.assign({},this.diy)
              style.top = data.top
              style.left = data.left
              style.type = data.type
              if(data.type == 1){
                style.opacity = data.opacity?data.opacity:1
                if(data.coverImgBase64) {
                  style.bg = "data:image/jpeg;base64,"+data.coverImgBase64
                }else{
                  style.bg  = require('@/assets/img/bg'+data.defaultCoverImg+'.png')
                }

              }else{
                style.bgColor = data.color
              }
              this.diy = style
            }
          },
            //清空所有的定时嚣
            clearAllSetTimeOut(){
                clearTimeout(this.otpInterval)
                clearTimeout(this.uafInterval)
                clearTimeout(this.fastPassInterval)
                clearTimeout(this.codeTimer)
            },
            goLogin() {
                let params = {
                    authToken: decodeURIComponent(window.location.href).match(/authToken=(\S*)/)[1],
                    reqId:sessionStorage.getItem('fastPassReqId')
                }
                authLogin(params).then(res=> {
                    if (res.code == this.$GLOBA.StatusOK) {
                        this.loginSuccess(1, res)
                    }else if(res.code == 201) {
                        this.authMfaFunc(res.data.authenticators)
                    }else if(res.code == 203){
                        //203 扫码登录
                        this.newScanCode(res.data.qrCode)
                    }
                })
            },
           authenticatorsUser(params){
                reqGetAuthenticators(params).then(res=>{
                    if(res.code == 201) {
                        this.authMfaFunc(res.data.authenticators)
                        sessionStorage.setItem('fastPassReqId',res.data.reqId)
                        sessionStorage.setItem('fastPassUserName',this.formData.username)
                        this.loadingButton = false
                    }else if(res.code == 203){
                        this.isScanLogin = true
                        sessionStorage.setItem('fastPassReqId',res.data.reqId)
                        sessionStorage.setItem('fastPassUserName',this.formData.username)
                        this.newScanCode(res.data.qrCode)
                        this.loadingButton = false
                    }else{
                        this.loadingButton = false
                        store.dispatch('snackbar/openSnackbar',{
                            snackbarText: res.message,
                            colorType: 'error'
                        })
                    }
                })
            },

            //点击登录按钮操作
            async  onSubmit() {
                this.loadingButton = true
                let self = this
                //如果没有认证用户
                if(!this.isAuthUserName) {
                    if (this.$refs.ruleForm.validate()) {
                        const fpPromise = FingerprintJS.load({
                                monitoring: false
                            })
                        ;(async () => {
                            // Get the visitor identifier when you need it.
                            const fp = await fpPromise
                            const result = await fp.get()
                            let params ={username:this.formData.username,platform:platformType(),fingerprint:result.visitorId,fastLoginBind:true}
                            this.authenticatorsUser(params)
                        })()
                    }else{
                        self.loadingButton = false
                    }
                }else {
                    if(this.showFUSBKey == "fidoUaf" && this.uafText == this.$t('login.push')){
                        this.pushFidoUaf()
                    }else if (this.showFUSBKey == "fidoU2f") {
                        if (window.PublicKeyCredential === undefined ||
                            typeof window.PublicKeyCredential !== "function") {
                            var errorMessage = this.$t('login.notSupportWeb')
                            if (window.location.protocol === "http:"){
                                errorMessage = this.$t('login.supportSecurity')
                            }
                            store.dispatch('snackbar/openSnackbar',{
                                snackbarText: errorMessage,
                                colorType: 'error'
                            })
                            this.loadingButton = false
                            return;
                        }
                        try{
                            this.fiao2Auth()
                        }catch (e) {
                            this.loadingButton = false
                        }
                    }else if (this.showFUSBKey == "fastLogin"){
                        this.fastLoginStart()
                    }else {
                        this.clearAllSetTimeOut()
                      if(this.showFUSBKey == 'pwd') {
                        //验证码
                        this.refreshVerify()
                      }else{
                        this.multipleFuncAuth()
                      }

                    }
                }
            },
            //这里走其它方式认证（微信，飞书等）
            restsFun(val) {
                this.restsObj = val
                // needPwd=true LDAP登录
                if (val.needPwd) {
                    this.sourceName = val.sourceName
                    this.isLdap = true
                    this.isLogin = false
                } else {

                    this.$serverUrlFun().then(serverUrl=> {
                        var url = serverUrl + '/authSrc/authorize/';
                        var formStr = '<form style="visibility:hidden;" method="POST" action="' + url + '">' +
                            '<input type="hidden" name="sourceKey" value="' + val.key + '" />' +
                            '<input type="hidden" name="appKey" value="' + this.$route.query.appKey + '" />' +
                            '<input type="hidden" name="reqId" value="' + sessionStorage.getItem('fastPassReqId') + '" />'+
                            '<input type="hidden" name="callback" value="' + window.location.href + '" />'+
                            '</form>';
                        var win = window.open("", "_self",);
                        win.document.body.innerHTML = formStr;
                        win.document.forms[0].submit();
                    })
                }
            },
            retrieveFun() {
                this.isType = "retrieve"
            },
            goBack() {
                this.isType = ""
            },
            namePwdFun() {
                this.isLdap = false
                this.isType = ""
            },
            //显示多因素
            authMfaFunc(data) {
                this.isType = ''
                this.password = null
                this.isAuthUserName = true
                if(!this.thirdCode.includes(data[0].code)) {
                    this.selectedMfaIndex = data[0].code
                }
                if(data[0].code == 337 || data[0].code == 338){
                    this.restsObj = data[0]
                    this.showFUSBKey = data[0].type
                    this.selectAuthInfo = data[0]
                }else{
                    this.showFUSBKey = data[0].key
                    if(data[0].key == 'scanLogin'){
                        this.getScanLoginQrcode()
                    }
                }

                this.authenticators = data



            },

            imgLarge(src,index){
                let phoneFlag = /(android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini)/i.test(navigator.userAgent)
                if(!phoneFlag){
                    let imgFocus = document.getElementsByClassName("img1_normal")[index]
                    imgFocus.style.height = "40px"
                }
            },
            imgSmall(src,index){
                let imgFocus = document.getElementsByClassName("img1_normal")[index]
                imgFocus.style.height = "36px"
            },
            rowFun(val,index) {



                if(this.showFUSBKey == "scanLogin" && val.key == 'scanLogin'){
                    return
                }
                this.selectAuthInfo = val
                //只要切换认证源就清除定时嚣
                this.clearAllSetTimeOut()
                if(val.type == 'authSrc') {
                    this.restsFun(val)
                }else{
                    this.selectedMfaIndex = val.code
                    this.restsObj = val
                    if(val.type == 'ldap'){
                        this.showFUSBKey = val.type
                    }else{
                        this.showFUSBKey = val.key
                    }
                    switch (val.key) {
                        case "fidoUaf":
                            this.uafText = this.$t('login.push')
                            break
                        case "otp":
                            this.otpText = this.$t('login.push')
                            break
                        case "scanLogin":
                            this.getScanLoginQrcode()
                            break
                    }
                    this.$nextTick(()=>{
                        if(val.type == 'ldap'){
                            this.$refs[val.type].focus()
                        }else{
                            if(!["fidoUaf",'fidoU2f',"otp",'scanLogin'].includes(val.key)){
                                this.$refs[val.key].focus()
                            }
                        }

                    })
                }

            },


            pushFun() {
                if (this.otpText == this.$t('push.text')) {
                    let params = {
                        reqId:sessionStorage.getItem('fastPassReqId'),
                    }
                    let pushOtpFunc = (params)=>{
                        pushOtp(params).then(res=> {
                            if(!params.otpReqId){
                                params.otpReqId= res.data
                            }
                            if (res.code == this.$GLOBA.StatusScanningOK) {
                                this.otpText--
                                this.otpInterval = setTimeout(()=>{
                                    pushOtpFunc(params)
                                },1000)
                                this.scanResult(res,this.otpInterval,4)
                                if(this.otpText <= 0) {
                                    clearTimeout(this.otpInterval)
                                    this.otpText = this.$t('push.text')
                                }
                            }else{
                                this.scanResult(res,this.otpInterval,4)
                            }
                        })
                    }
                    this.otpText = 60
                    pushOtpFunc(params)
                }
            },
            refreshLogin(){
                location.reload()
            },
            scanLoginQrcode(qrcode){
                this.$nextTick(()=>{
                    let qrcodeCreater = new QRCode(this.$refs.qrScanLoginCodeUrl, {
                        text: qrcode,
                        colorDark: '#000000',
                        colorLight: '#ffffff',
                        typeNumber: 4,
                        width: 200,
                        height: 200,
                        correctLevel: QRCode.CorrectLevel.L
                    })
                    qrcodeCreater._el.title = ""
                })
            },
            getScanLoginQrcode(){
                reGetQrcode().then(res=>{
                    if(res.code == 200) {
                        this.scanLoginQrcode(res.data.qrcode)
                        this.qrScanLoginCodeChange(res.data.reqId)
                    }else{
                        store.dispatch('snackbar/openSnackbar',{
                            snackbarText: res.message,
                            colorType: 'error'
                        })
                    }
                })
            },

            // 扫码登录
            getRefreshScanloginCode(key) {
                if (key == "refresh") {
                    this.$refs.qrScanLoginCodeUrl.innerHTML = null
                    this.showStale = false
                }
                this.getScanLoginQrcode()
            },

            qrScanLoginCodeChange(scanReqId) {
                let params = {
                    reqId:sessionStorage.getItem('fastPassReqId'),
                    scanReqId:scanReqId
                }
                let reqScanLoginFunc = (params) =>{
                    reqScanLogin(params).then(res3=> {
                        num ++
                        this.codeTimer = setTimeout(()=>{
                            reqScanLoginFunc(params)
                        },1000)
                        if (res3.code == this.$GLOBA.StatusOK) {
                            clearTimeout(this.codeTimer)
                            this.loginSuccess(5, res3)
                        } else if (res3.code == this.$GLOBA.StatusRequestEntityTooLarge) {
                            clearTimeout(this.codeTimer)
                            this.qrCodeSuccess = false
                            this.showStale = true
                            this.qrText = this.$t('login.qrText')
                        } else if (res3.code == this.$GLOBA.StatusScanningOK) {
                            if (res3.data) {
                                // 二维码扫码成功后重置定时器
                                if (!this.qrCodeSuccess) {
                                    num = 0
                                }
                                this.qrCodeSuccess = true
                            }
                        }else if (res3.code == 201) {
                            clearTimeout(this.codeTimer)
                            this.authMfaFunc(res3.data.authenticators)
                            this.isScanLogin = false
                        }else if(res3.code == 203){
                            //203 扫码登录
                            clearTimeout(this.codeTimer)
                            this.newScanCode(res3.data.qrCode)
                        } else if (res3.code == this.$GLOBA.StatusQCodeInvalid) {
                            this.qrCodeSuccess = false
                            clearTimeout(this.codeTimer)
                            this.qrText = this.$t('login.qrLoseEfficacy')
                            this.showStale = true
                        } else if(res3.code == this.$GLOBA.StatusFound) {
                            clearTimeout(this.codeTimer)
                            this.$cookieStore.setCookie('userInfo', res3.data.userInfo)
                            this.subForm(res3.data)
                        }else if (res3.code ==  this.$GLOBA.StatusAcceptedUpdatePwd) {
                            clearTimeout(this.codeTimer)
                            this.$cookieStore.setCookie('username',sessionStorage.getItem('username'));
                            this.constraintPwd(res3.data.updatePwdToken)
                        }else if(res3.code == 512){
                            clearTimeout(this.codeTimer)
                            this.qrText  = res3.message
                            this.showStale = true
                            this.qrCodeSuccess = false
                            // this.isScanLogin = false

                        }else if(res3.code == 507){
                            this.qrCodeSuccess = false
                            clearTimeout(this.codeTimer)
                            this.qrText = this.$t('login.qrLoseEfficacy')
                            this.showStale = true
                        } else {
                            this.showStale = true
                            this.qrCodeSuccess = false
                            clearTimeout(this.codeTimer)
                            this.qrText  = res3.message
                        }
                        if(num > 60) {
                            clearTimeout(this.codeTimer)
                            this.showStale = true
                            this.qrCodeSuccess = false
                            this.qrText = this.$t('login.qrText')
                        }
                    })
                }
                let num = 0
                reqScanLogin(params).then(res2=> {
                    if (res2.code == this.$GLOBA.StatusScanningOK) {
                        reqScanLoginFunc(params)
                    } else {
                        this.qrText  = res2.message
                        this.showStale = true
                    }
                })
            },

            // 扫码登录
            getCode(key) {
                if (key == "refresh") {
                    this.$refs.qrCodeUrl.innerHTML = null
                    this.showFenceStale = false
                    this.isRefresh = false
                }
                let params = {
                    reqId:sessionStorage.getItem('fastPassReqId')
                }
                reqRefreshLocationQrCode(params).then(res=>{
                    if(res.code == this.$GLOBA.StatusOK) {
                        // 生成二维码
                        let qrcodeCreater = new QRCode(this.$refs.qrCodeUrl, {
                            text: res.data.qrCode,
                            colorDark: '#000000',
                            colorLight: '#ffffff',
                            typeNumber: 4,
                            width: 200,
                            height: 200,
                            correctLevel: QRCode.CorrectLevel.L
                        })
                        qrcodeCreater._el.title = ""
                        // 二维码状态监听
                        this.qrCodeChange(res.data.reqId)
                    }else if(res.code == 1014){
                        setTimeout(()=>{
                            location.reload();
                        },500)
                        store.dispatch('snackbar/openSnackbar',{
                            snackbarText: res.message,
                            colorType: 'error'
                        })
                    }else{
                        store.dispatch('snackbar/openSnackbar',{
                            snackbarText: res.message,
                            colorType: 'error'
                        })
                    }
                })
            },
            qrCodeChange() {
                let params = {
                    reqId:sessionStorage.getItem('fastPassReqId')
                }

                let reqCheckFenceFunc = (params)=>{
                    reqCheckFence(params).then(res3=>{
                        num ++
                        this.codeTimer = setTimeout(()=>{
                            reqCheckFenceFunc(params)
                        },1000)
                        if (res3.code == this.$GLOBA.StatusOK) {
                            clearTimeout(this.codeTimer)
                            this.loginSuccess(5, res3)
                        } else if (res3.code == this.$GLOBA.StatusRequestEntityTooLarge) {
                            clearTimeout(this.codeTimer)
                            this.showFenceStale = true
                            this.qrFenceText = this.$t('login.qrText')
                        } else if (res3.code == this.$GLOBA.StatusScanningOK) {

                        }else if (res3.code == 201) {
                            clearTimeout(this.codeTimer)
                            this.authMfaFunc(res3.data.authenticators)
                            this.isScanLogin = false
                        }else if(res3.code == 203){
                            //203 扫码登录
                            clearTimeout(this.codeTimer)
                            this.newScanCode(res3.data.qrCode)
                        } else if (res3.code == this.$GLOBA.StatusQCodeInvalid) {
                            clearTimeout(this.codeTimer)
                            this.qrFenceText = this.$t('login.qrLoseEfficacy')
                            this.showFenceStale = true
                        } else if(res3.code == this.$GLOBA.StatusFound) {
                            clearTimeout(this.codeTimer)
                            this.$cookieStore.setCookie('userInfo', res3.data.userInfo)
                            this.subForm(res3.data)
                        }else if (res3.code ==  this.$GLOBA.StatusAcceptedUpdatePwd) {
                            clearTimeout(this.codeTimer)
                            this.$cookieStore.setCookie('username',sessionStorage.getItem('username'));
                            this.constraintPwd(res3.data.updatePwdToken)
                        }else if(res3.code == 512){
                            clearTimeout(this.codeTimer)
                            this.qrFenceText  = res3.message
                            this.showFenceStale = true
                            this.isRefresh = true
                        }else if(res3.code == 507){
                            clearTimeout(this.codeTimer)
                            this.qrFenceText = this.$t('login.qrLoseEfficacy')
                            this.showFenceStale = true
                        }else if(res3.code == 1014){
                            this.showFenceStale = true
                            clearTimeout(this.codeTimer)
                            this.qrFenceText  = res3.message
                            this.isRefresh = true
                        } else {
                            this.showFenceStale = true
                            clearTimeout(this.codeTimer)
                            this.qrFenceText  = res3.message
                        }
                        if(num > 60) {
                            clearTimeout(this.codeTimer)
                            this.showFenceStale = true
                            this.isRefresh = true
                            this.qrFenceText = this.$t('login.qrText')
                        }
                    })
                }
                let num = 0
                reqCheckFence(params).then(res2=> {
                    if (res2.code == this.$GLOBA.StatusScanningOK) {
                        reqCheckFenceFunc(params)
                    } else {
                        this.qrFenceText  = res2.message
                        this.showFenceStale = false
                    }
                })
            },

            getPhoneCode() {
                if (this.codeText == this.$t('push.sendCode')) {
                    this.spinning = true
                    let params = {
                        reqId:sessionStorage.getItem('fastPassReqId'),
                        smsType: this.$getSmsModel('login')
                    }
                    sendSms(params).then(res=>{
                        this.spinning = false
                        if (res.code == this.$GLOBA.StatusOK) {
                            store.dispatch('snackbar/openSnackbar',{
                                snackbarText: res.message,
                                colorType: 'success'
                            })
                            if(this.codeText == this.$t('push.sendCode')) {
                                this.codeText = 60
                                let timer = setInterval(()=>{
                                    this.codeText--
                                    if(this.codeText <= 0) {
                                        clearInterval(timer)
                                        this.codeText = this.$t('push.sendCode')
                                    }
                                },1000)
                            }
                        }else{
                            store.dispatch('snackbar/openSnackbar',{
                                snackbarText: res.message,
                                colorType: 'error'
                            })
                        }
                    }).catch(err=> {
                        this.spinning = false
                    })
                }
            },
            getEmailCode() {
                // this.spinning = true
                if (this.emailText == this.$t('push.sendCode')) {
                    this.spinning = true
                    let params = {
                        reqId:sessionStorage.getItem('fastPassReqId'),
                        emailType: this.$getEmailModel('login')
                    }
                    sendEmail(params).then(res=> {
                        this.spinning = false
                        if (res.code == this.$GLOBA.StatusOK) {
                            store.dispatch('snackbar/openSnackbar',{
                                snackbarText: res.message,
                                colorType: 'success'
                            })
                            this.emailText = 60
                            let timer = setInterval(()=>{
                                this.emailText--
                                if(this.emailText <= 0) {
                                    clearInterval(timer)
                                    this.emailText = this.$t('push.sendCode')
                                }
                            },1000)
                        }else{
                            store.dispatch('snackbar/openSnackbar',{
                                snackbarText: res.message,
                                colorType: 'error'
                            })
                        }
                    }).catch(err=> {
                        this.spinning = false
                    })
                }
            },

            newScanCode(qrcode){
                this.isScanLogin = true
                this.$nextTick(()=>{
                    let qrcodeCreater = new QRCode(this.$refs.qrCodeUrl, {
                        text: qrcode,
                        colorDark: '#000000',
                        colorLight: '#ffffff',
                        typeNumber: 4,
                        width: 200,
                        height: 200,
                        correctLevel: QRCode.CorrectLevel.L
                    })
                    qrcodeCreater._el.title = ""
                })


                // 二维码状态监听
                this.qrCodeChange()
            },
            pushFidoUaf() {
                if (this.uafText == this.$t('push.text')) {
                    let params = {reqId: sessionStorage.getItem('fastPassReqId')}
                    let pushFidoUafFunc = (params)=>{
                        this.loadingButton = false
                        pushUaf(params).then(res => {
                            if(!params.uafReqId){
                                params.uafReqId = res.data
                            }
                            if (res.code == this.$GLOBA.StatusScanningOK) {
                                    this.uafText--
                                    this.uafInterval = setTimeout(() => {
                                        pushFidoUafFunc(params)
                                    }, 1000)
                                    this.scanResult(res,this.uafInterval,6)
                                    if (this.uafText <= 0) {
                                        clearTimeout(this.uafInterval)
                                        this.uafText = this.$t('push.text')
                                    }
                            } else {
                                this.scanResult(res,this.uafInterval,6)
                            }
                        })
                    }
                    this.uafText = 60
                    pushFidoUafFunc(params)
                }
　
            },
            fastLoginStart(){
                reqFastLoginStart({reqId:sessionStorage.getItem("fastPassReqId")}).then(res=>{
                    if(res.code == 200) {
                        //換起應用
                        this.callApp(res.data)
                    }else{
                        store.dispatch('snackbar/openSnackbar',{
                            snackbarText: res.message,
                            colorType: 'error'
                        })
                    }
                })

            },
            //轮询结果处理
            scanResult(res,timeOut,key){
                // key 1.自动登录 2.多因素登录 3.账号密码登录 4.otp推送 5.扫码登录 6.Uaf推送 7.绑定账户登录,11,飞天云信令
                if (res.code == this.$GLOBA.StatusOK) {
                    if(timeOut){
                        clearTimeout(timeOut)
                    }
                    this.loginSuccess(key, res)
                }else if(res.code == 201) {
                    timeOut && clearTimeout(timeOut)
                    this.authMfaFunc(res.data.authenticators)
                    this.isScanLogin = false
                }else if(res.code == 203){
                    //203 扫码登录
                    timeOut && clearTimeout(timeOut)
                    this.newScanCode(res.data.qrCode)
                } else if (res.code == this.$GLOBA.StatusAcceptedUpdatePwd) {
                    // 新用户强制修改密码
                    timeOut && clearTimeout(timeOut)
                    if(key == 4) {
                        this.otpText = this.$t('push.text')
                    }
                    this.$cookieStore.setCookie('username', sessionStorage.getItem('fastPassUserName'));
                    this.constraintPwd(res.data.updatePwdToken)
                }else if(res.code == this.$GLOBA.StatusFound) {
                    timeOut && clearTimeout(timeOut)
                    this.$cookieStore.setCookie('userInfo', res.data.userInfo)
                    this.subForm(res.data)
                }else {
                    if (key == 2) {
                        if (res.message.indexOf("已锁定") > -1) {
                            store.dispatch('snackbar/openSnackbar',{
                                snackbarText: this.$t('browser.FIDO2Look'),
                                colorType: 'error'
                            })
                        } else if (res.message.indexOf("未启用") > -1) {
                            store.dispatch('snackbar/openSnackbar',{
                                snackbarText: this.$t('browser.FIDO2Err'),
                                colorType: 'error'
                            })
                        } else {
                            store.dispatch('snackbar/openSnackbar',{
                                snackbarText: res.message,
                                colorType: 'error'
                            })
                        }
                    } else if (res.code != 422) {
                        timeOut && clearTimeout(timeOut)
                        if (key == 6) {
                            this.uafText = this.$t('push.text')
                        } else if (key == 4) {
                            this.otpText = this.$t('push.text')
                        }
                        store.dispatch('snackbar/openSnackbar',{
                            snackbarText: res.message,
                            colorType: 'error'
                        })
                    }
                }
            },
            fastLogin(){
                let params = {
                    reqId:sessionStorage.getItem('fastPassReqId'),
                }
                let fastLoginFunc = (params)=>{
                    reqFastLogin(params).then(res=>{
                        this.loadingButton = false
                        if (res.code == this.$GLOBA.StatusScanningOK) {
                            num ++
                            this.fastPassInterval = setTimeout(()=>{
                                fastLoginFunc(params)
                            },1000)
                            this.scanResult(res,this.fastPassInterval,11)
                            if(num > 60) {
                                clearTimeout(this.fastPassInterval)
                            }
                        } else {
                            this.scanResult(res,this.fastPassInterval,11)
                        }

                    })
                }
                let num = 0
                fastLoginFunc(params)
            },
            // 多因素认证判断
            async filterData(params) {
                let typeData = {}
                if(this.showFUSBKey == 'pwd') {
                    //pwd
                    if(!this.password){
                        store.dispatch('snackbar/openSnackbar',{
                            snackbarText: this.$t('login.pwdNotEmpty'),
                            colorType: 'error'
                        })
                        this.loadingButton = false
                        return
                    }
                    let pwd = await this.$passwordEncryption(this.password)
                  let  data =  {
                    password: pwd,
                    reqId:sessionStorage.getItem('fastPassReqId')
                  }
                  typeData = {
                    data:params?Object.assign(data,params):data,
                    apiType: reqLoginPwd
                  }
                    // typeData = {
                    //     data: {
                    //         password: pwd,
                    //         reqId:sessionStorage.getItem('fastPassReqId')
                    //     },
                    //     apiType: reqLoginPwd
                    // }
                }else if(this.showFUSBKey == 'ldap'){
                    if(!this.password){
                        store.dispatch('snackbar/openSnackbar',{
                            snackbarText: this.$t('login.pwdNotEmpty'),
                            colorType: 'error'
                        })
                        this.loadingButton = false
                        return
                    }
                    let pwd = await this.$passwordEncryption(this.password)
                    typeData = {
                        data: {
                            password: pwd,
                            reqId:sessionStorage.getItem('fastPassReqId'),
                            sourceKey: this.restsObj.key,
                            username: sessionStorage.getItem("fastPassUserName")
                        },
                        apiType: ldapLogin
                    }
                }else if (this.showFUSBKey == 'otp') {
                    //otp
                    this.otpText = this.$t('login.push')
                    if (!this.fUSBKeyData) {
                        this.loadingButton = false
                        store.dispatch('snackbar/openSnackbar',{
                            snackbarText: this.$t('login.dynamicPassword'),
                            colorType: 'error'
                        })
                        return false
                    } else {
                        typeData = {
                            data: {
                                otp: this.fUSBKeyData,
                                reqId:sessionStorage.getItem('fastPassReqId')
                            },
                            apiType: checkOtp
                        }
                    }
                } else if (this.showFUSBKey == 'phoneCode') {
                    // 短信验证码登录
                    if (!this.phoneCode) {
                        this.loadingButton = false
                        store.dispatch('snackbar/openSnackbar',{
                            snackbarText: this.$t('login.messageAuthenticationCode'),
                            colorType: 'error'
                        })
                        return false
                    } else {
                        typeData = {
                            data: {
                                phoneCode: this.phoneCode,
                                reqId:sessionStorage.getItem('fastPassReqId')
                            },
                            apiType: phoneLogin
                        }
                    }
                } else if (this.showFUSBKey == 'email') {
                    // 邮箱验证码登录
                    if (!this.emailCode) {
                        this.loadingButton = false
                        store.dispatch('snackbar/openSnackbar',{
                            snackbarText: this.$t('login.emailCode'),
                            colorType: 'error'
                        })
                        return false
                    } else {
                        typeData = {
                            data: {
                                reqId:sessionStorage.getItem('fastPassReqId'),
                                emailCode: this.emailCode
                            },
                            apiType: emailLogin
                        }
                    }
                } else if (this.showFUSBKey == 'tempLogin') {
                    // 临时认证
                    if (!this.tempLoginData) {
                        this.loadingButton = false
                        store.dispatch('snackbar/openSnackbar',{
                            snackbarText: this.$t('login.temporaryPwd'),
                            colorType: 'error'
                        })
                        return false
                    } else {
                        typeData = {
                            data: {
                                tempToken: this.tempLoginData,
                                reqId:sessionStorage.getItem('fastPassReqId')
                            },
                            apiType: tempLogin
                        }
                    }
                } else {
                    this.loadingButton = false
                    return false
                }
                return typeData
            },
          multipleFuncAuth(data) {
            this.filterData(data)
              .then(typeData => {
                if (typeData && typeData.apiType) {
                  typeData.apiType(typeData.data)
                    .then(res => {
                      this.loadingButton = false
                      if(this.showFUSBKey == 'pwd') {
                        this.closeAllCapta()
                      }
                      if (res.code == this.$GLOBA.StatusOK) {
                        this.loginSuccess(2, res)
                      } else if (res.code == 201) {
                        this.authMfaFunc(res.data.authenticators)
                      } else if (res.code == 203) {
                        this.newScanCode(res.data.qrCode)
                      } else if (res.code == this.$GLOBA.StatusAcceptedUpdatePwd) {
                        // 新用户强制修改密码
                        this.$cookieStore.setCookie('username', sessionStorage.getItem('fastPassUserName'));

                        this.constraintPwd(res.data.updatePwdToken)
                      } else if (res.code == this.$GLOBA.StatusFound) {

                        // window.open(res.data.redirectUrl, "_self")
                      }else if(res.code == 2034){

                        this.refreshVerify()
                        store.dispatch('snackbar/openSnackbar', {
                          snackbarText: res.message,
                          colorType: 'error'
                        })
                      }  else {
                        store.dispatch('snackbar/openSnackbar', {
                          snackbarText: res.message,
                          colorType: 'error'
                        })
                      }
                    })
                } else if (!this.showFUSBKey) {
                  this.loadingButton = false
                  store.dispatch('snackbar/openSnackbar', {
                    snackbarText: this.$t('browser.authenticationMethod'),
                    colorType: 'error'
                  })
                }
              })
          },

          refreshVerify(){
            this.captchaType = ""
            reqGet({reqId:sessionStorage.getItem('fastPassReqId')}).then(res => {
              if(res.code == 200) {
                if(res.data.verifyCodeMode > 0) {
                  this.captchaType = res.data.verifyCodeMode == 1 ? 'blockPuzzle' : res.data.verifyCodeMode == 2 ? 'clickWord' : 'calculateAnswer'
                  this.verificationData = {
                    originalImageBase64:res.data.originalImageBase64,
                    secretKey:res.data.secretKey,
                    token:res.data.token
                  }
                  if( res.data.verifyCodeMode == 1) {
                    this.verificationData.jigsawImageBase64 = res.data.jigsawImageBase64
                  }
                  if( res.data.verifyCodeMode == 2) {
                    this.verificationData.wordList = res.data.wordList
                  }
                  this.$refs.verifyBox.useVerify()
                }
              }
            })
          },
          closeVerifyBox(){
            this.$refs.verifyBox.$refs.verify.closeBox()
            this.loadingButton = false
          },
          closeAllCapta(){
            this.closeVerifyBox()
          },
            editSubmit() {
                this.isType = null
                this.isLdap = false
                this.showFUSBKey = null
                this.formData = {}
                this.isLogin = false
            },
            // 强制改密
            constraintPwd(updatePwdToken) {
                this.visible = false
                this.isType = 'editPwd'
                this.editToken = updatePwdToken
            },
            // 子账号判断
            subForm(val) {

            },
            encode(str){
                // 对字符串进行编码
                var encode = encodeURI(str);
                // 对编码的字符串转化base64
                var base64 = btoa(encode);
                return base64;
            },
            // 登录成功后判断
            loginSuccess(key, val) {
                // redirectUrl判断其他网页登录，跳转到redirectUrl网页
                  if(window.location.href.indexOf("redirectUrl") > -1) {
                    this.urlFilter()
                 }

            },
            urlFilter() {
                // window.open(decodeURIComponent(window.location.href.match(/redirectUrl=(\S*)/)[1]), "_self")
                let urls = decodeURIComponent(window.location.href.match(/redirectUrl=(\S*)/)[1]) // 获取外部http所有信息
                let str = '' //处理后的数据集合
                if(urls.indexOf("?") > -1) { // 判断是否有参数
                    let num1 = urls.split("?")[0] // 域名地址
                    let num2 = urls.split("?")[1] // 所有的参数集合
                    // 判断是否有第二个参数
                    if (num2.indexOf("&") > -1) {
                        for (let item of num2.split("&")) {
                            if (item.indexOf("=") > -1) {
                                let y1 = item.slice(0, item.indexOf("="))
                                // 参数编码
                                let y2 = encodeURIComponent(item.slice(item.indexOf("=")+1))
                                let y3 = y1+'='+y2+"&"
                                str += y3
                            }
                        }
                        str = num1 +'?'+ str.slice(0, str.length-1)
                    } else {
                        // 一个参数直接拼接
                        let y1 = num2.slice(0, num2.indexOf("="))
                        let y2 = encodeURIComponent(num2.slice(num2.indexOf("=")+1))
                        str = num1 +'?'+ y1+'='+y2
                    }
                } else {
                    str = urls
                }

               window.open(str+'&reqId='+sessionStorage.getItem('fastPassReqId'), "_self")
            },
            fiao2Auth(){
                let self = this
                fido2AuthStart({reqId:sessionStorage.getItem('fastPassReqId')}).then(apiResponseData=> {
                    this.loadingButton = false
                    return new Promise(function(resolve, reject) {
                        var returnInfo = {};
                        if (apiResponseData.code != 200) {
                            store.dispatch('snackbar/openSnackbar',{
                                snackbarText: apiResponseData.message,
                                colorType: 'error'
                            })
                        } else {
                            var businessData = apiResponseData.data

                            var reqid = businessData.reqId;
                            var fido2_data = JSON.parse(businessData.fido2Data)

                            var requestOptions = {};
                            requestOptions.challenge = base64urlDecode(fido2_data.challenge);
                            if ('timeout' in fido2_data) {
                                requestOptions.timeout = fido2_data.timeout;
                            }
                            if ('rpId' in fido2_data) {
                                requestOptions.rpId = fido2_data.rpId;
                            }

                            if ('allowCredentials' in fido2_data) {
                                requestOptions.allowCredentials = self.credentialListConversion(fido2_data.allowCredentials);
                            }

                            if (typeof navigator.credentials.get !== "function") {
                                store.dispatch('snackbar/openSnackbar',{
                                    snackbarText: this.$t('browser.errorAuthentication'),
                                    colorType: 'error'
                                })
                            }
                            navigator.credentials.get({
                                "publicKey": requestOptions
                            }).then(function(assertion) {
                                var authConfirmFido2Data = {};
                                if ('id' in assertion) {
                                    authConfirmFido2Data.id = assertion.id;
                                }
                                if ('type' in assertion) {
                                    authConfirmFido2Data.type = assertion.type;
                                }
                                if ('rawId' in assertion) {
                                    authConfirmFido2Data.rawId = assertion.rawId;
                                }
                                if ('response' in assertion) {
                                    var response = {};
                                    response.clientDataJSON = base64urlEncode(assertion.response.clientDataJSON);
                                    response.authenticatorData = base64urlEncode(assertion.response.authenticatorData);
                                    response.signature = base64urlEncode(assertion.response.signature);
                                    response.userHandle = base64urlEncode(assertion.response.userHandle);
                                    authConfirmFido2Data.response = response;
                                    authConfirmFido2Data.username = sessionStorage.getItem('fastPassUserName');
                                    resolve(self.authConfirm(authConfirmFido2Data, reqid));
                                }
                            }).catch(function(err) {
                                if (err.toString().indexOf("A request is already pending") > -1){
                                    store.dispatch('snackbar/openSnackbar',{
                                        snackbarText: self.$t('browser.arouse'),
                                        colorType: 'error'
                                    })
                                }else{
                                    store.dispatch('snackbar/openSnackbar',{
                                        snackbarText: self.$t('browser.overtime'),
                                        colorType: 'error'
                                    })
                                }

                            });
                        }
                    });
                })

            },


            credentialListConversion(list) {
                var result = [];
                for (var i = 0; i < list.length; i++) {
                    var credential = {};
                    credential.type = list[i].type;
                    credential.id = base64urlDecode(list[i].id);
                    if ('transports' in list) {
                        credential.transports = list.transports;
                    }
                    result.push(credential);
                }
                return result;
            },
            authConfirm(authConfirmFido2Data, reqid) {
                this.loadingButton = false
                fido2AuthConfirm({
                    fido2ReqId: reqid,
                    reqId:sessionStorage.getItem('fastPassReqId'),
                    fido2Data: JSON.stringify(authConfirmFido2Data),
                    username: sessionStorage.getItem('fastPassUserName')
                }).then(res=> {
                    this.scanResult(res,null,2)
                })
            },
            keydown(e) {
                if(e.key == "Enter") {
                    this.onSubmit()
                }
            },

        },
    }
</script>

<style lang='scss' scoped>
  .ant-tooltip-arrow {
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    left: 50%;

    bottom: -0.66412vw;
    position: absolute;
    display: block;
    width: 0.68078vw;
    height: 0.68078vw;
    overflow: hidden;
    background: transparent;
    pointer-events: none;
  }
  .ant-tooltip-arrow::before {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: block;
    width: 0.34042rem;
    height: 0.34042rem;
    margin: auto;
    background-color: rgba(0, 0, 0, 0.75);
    -webkit-box-shadow: 0.15625vw 0.15625vw 0.36458vw rgba(0, 0, 0, 0.07);
    box-shadow: 0.15625vw 0.15625vw 0.36458vw rgba(0, 0, 0, 0.07);
    -webkit-transform: translateY(-0.34039vw) rotate(45deg);
    transform: translateY(-0.34039vw) rotate(45deg);

    content: '';
    pointer-events: auto;

  }

  @media (max-width: 700px) {
    .ant-tooltip-arrow {
      overflow: hidden;
      bottom: -0.2102rem;
      width: 0.30042rem;
      height: 0.30042rem;

    }
    .ant-tooltip-arrow::before{
      width: 0.30042rem;
      height: 0.30042rem;
      background-color: rgba(0, 0, 0, 0.70);

    }

  }
  @media (max-width: 550px) {
    .ant-tooltip-arrow {
      bottom: -0.172rem;
      width: 0.30042rem;
      height: 0.2542rem;
      overflow: hidden;
    }
    .ant-tooltip-arrow::before{
      width: 0.30042rem;
      height: 0.30042rem;

    }
  }


    .login-box {
        height: 100%;
        // min-height: 900px;
        // background: linear-gradient(143deg, #2E6BF7, #2EB7F7);
        display: flex;
        position: relative;
        .logo {
            position: absolute;
            top: 30px;
            left: 40px;
            height: 60px;
        }
        .tabs-box ::v-deep {
            // padding: 0 100px;
            text-align: center;
            .ant-tabs-bar {
                border: 0;
                margin: 10px 0 40px;
            }
            .ant-tabs-tab {
                font-size: 20px;
            }
            .ant-tabs-tab-active {
                color: #5066e0;
            }
            .ant-tabs-ink-bar {
                background: #5066e0;
            }
        }
        .ldap-title {
            margin: 40px 0 40px;
            font-size: 18px;
            text-align: center;
        }
        .pwd-box {
            // padding: 0 100px;
            max-width: 380px;
            margin: 40px auto 0px;
            .fusb-Key {
                display: flex;
                margin-top: 20px;
                margin-bottom: 10px;
            }
            .fido-u2f {
                font-size: 14px;
                color: #666;
                line-height: 24px;
                text-align: center;
            }
            .fido-uaf {
                justify-content: flex-end;
            }
            .more-input {
                font-size: 16px;
                height: 50px;
                border-radius: 30px;
                padding-left: 30px;
                background-color: #f5f5f5;
                border:none;
            }
            .more-input:focus {
                box-shadow: none;
            }
            .key-btn {
                height: 50px;
                width: 180px;
                margin-left: 50px;
                font-size: 18px;
                // background: #337DF7;
                border-radius: 25px;
            }

        }
        .ant-input-password ::v-deep {
            .ant-input-suffix {
                right: 20px;
            }

        }
        .scan-login-code-box {
            position: relative;
            height: 270px;
            margin: 0px auto;
            margin-bottom:20px;
            /*display: flex;*/
            .code {
                width: 100%;
                height: 260px;
                margin-bottom: 5px;
                display: flex;
                justify-content: center;
                align-items: center;
            }
            .code-box_txt{
                text-align: center;
                margin-bottom: 10px;
            }
            .stale-box, .qr-success-text {
                position: absolute;
                top: 0px;
                left: 50%;
                transform: translateX(-50%);
                width: 250px;
                height: 260px;
                background-color: rgba(255,255,255, 0.9);
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                font-size: 16px;
                a {
                    text-decoration: underline;
                }
                .qr-text {
                    padding: 10px 0;
                    font-weight: bold;
                }
            }
        }
        .code-box ::v-deep {
        margin-bottom: 30px;
        position: relative;
        width: 340px;
        height: 380px;
        margin: 30px auto 20px;
        display: flex;
        justify-content: center;
        background: #FFFFFF;
        padding: 21px;
        box-shadow: 0px 0px 14px 1px rgba(0, 0, 0, 0.16);
        img {
            width: 200px;
            margin: 0 auto;
            position: absolute;
            top: 56px;
            left: 69px;
        }
        .stale-img {
            width: 64px;
            height: 64px;
            left: 35%;
        }
        .text {
            margin-top: 10px;
            text-align: center;

        }
        .stale-box, .qr-success-text {
            position: absolute;
            top: 50px;
            left: 50%;
            transform: translateX(-50%);
            width: 220px;
            height: 220px;
            background-color: rgba(255,255,255, 0.9);
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            font-size: 16px;
            a {
                text-decoration: underline;
            }
            .qr-text {
                margin-top: 85px;
                padding: 10px 0;
                font-weight: bold;
                font-size: 16px;
                color: #666;
                text-align: center;
            }
        }
        .qr-success-text {
            text-align: center;
            // margin-top: 25px;
            font-weight: bold;
            .s-title {
                font-size: 18px;
                margin-bottom: 3px;
                margin-top: 20px;
            }
        }
            .code-box_txt{
                position: absolute;
                bottom: 28px;
                text-align: center;
                font-size: 13px;
            }
        .code {
            margin-top: 36px;
        }
    }
        // .code-box ::v-deep {
        //     margin-bottom: 30px;
        //     position: relative;
        //     img {
        //         margin: 0 auto;
        //     }
        //     .stale-img {
        //         width: 64px;
        //         height: 64px;
        //     }
        //     .text {
        //         margin-top: 10px;
        //         text-align: center;

        //     }
        //     .stale-box, .qr-success-text {
        //         position: absolute;
        //         top: 0;
        //         left: 50%;
        //         transform: translateX(-50%);
        //         width: 250px;
        //         height: 250px;
        //         background-color: rgba(255,255,255, 0.9);
        //         display: flex;
        //         align-items: center;
        //         justify-content: center;
        //         flex-direction: column;
        //         font-size: 16px;
        //         a {
        //             text-decoration: underline;
        //         }
        //         .qr-text {
        //             padding: 10px 0;
        //             font-weight: bold;
        //         }
        //     }
        //     .qr-success-text {
        //         text-align: center;
        //         // margin-top: 25px;
        //         font-weight: bold;
        //         .s-title {
        //             font-size: 18px;
        //             margin-bottom: 3px;
        //             margin-top: 20px;
        //         }
        //     }
        // }
        .box {
            // margin: 100px 100px 65px;
            /*background: #FFFFFF;*/
            box-shadow: 0px 15px 50px 0px rgba(103, 182, 206, 0.27);
            // border-radius: 20px;
            flex: 1;
            display: flex;
            .login-icon {
                width: 100%;
                z-index: 1;
            }
            .img-box {
                position: relative;
                width: 100%;
                height: 100%;
            }
            .login-title-icon {
                position: absolute;
                z-index: 1;
                height: 100%;
                right: 0;
                width: 100%;
                top: 0;
            }
            .right-box {
                // flex: 1;
                // min-width: 380px;
                width:400px;
                // padding-top:8%;
                // margin-left: 195px;
                // margin-right: -85px;
                z-index: 15;
                .box-title {
                    // height: 70px;
                    // line-height: 70px;
                    // padding-left: 95px;
                    // border-bottom: 1px solid rgba(0,0,0,.12);
                    font-size: 32px;
                    font-weight: 400;
                    text-align: center;
                    margin-bottom: 30px;
                    margin-top: 50px;
                }
                .sub-title {
                    font-size: 18px;
                    font-weight: 600;
                    color: #337DF7;
                    padding: 70px 0 50px;
                    text-align: center;
                }
                .form-box ::v-deep {
                    .ant-form-item {
                        margin-bottom: 30px;
                    }
                    .ant-input {
                        font-size: 16px;
                        height: 46px;
                        border-radius: 10px;
                        padding-left: 20px;
                        // background-color: #F5F5F5;
                        // border: none;
                    }
                    .ant-input:focus {
                        box-shadow:none;
                    }
                    // .ant-form-explain {
                    //     padding-left: 30px;
                    // }
                }
                .login-btn {
                    width: 100%;
                    height: 50px;
                    line-height: 50px;
                    background: #5066e0;
                    box-shadow: 0px 6px 12px 0px rgba(42, 154, 243, 0.35);
                    font-size: 16px;
                    font-weight: 500;
                    color: #FFFEFE;
                    margin-top: 10px;
                }
                .login-btn[disabled]{
                    color: rgba(0, 0, 0, 0.25);
                    background-color: #f5f5f5;
                    border-color: #d9d9d9;
                    text-shadow: none;
                    box-shadow: none;
                }

            }

            .right-box.auth-maf-content {
                margin: 0 auto;
            }
        }
        .tip {
            font-size: 16px;
            margin-top: 20px;
            font-weight: 500;
            color: #5066e0;
            cursor: pointer;
            .name-pwd {
                float: right;
            }
        }
        .rests-title {
            font-size: 20px;
            font-weight: 400;
            color: #666;
            margin: 20px 0 20px;
            text-align: center;
            span {
                margin: 0 20px;
            }
        }
        .more-title {
            font-size: 16px;
            color: #666;
            margin: 10px -10px 20px;
            text-align: center;
            span {
                margin: 0 10px;
            }
        }
        .more-box {
            text-align: left;
            .img_box{
                display: inline-block;
                height: 41px;
                width: 41px;
                text-align: center;
                line-height: 40px;
                margin: 0 8px 16px;
                position: relative;
                .img_shadow_none{
                    position: absolute;
                    left: 2px;
                    top: 4px;
                    width: 36px;
                    height: 36px;
                    display: none;
                }
            }
            img {
                height: 40px;
                cursor: pointer;
            }
            .img1_normal{
                height: 36px;
            }
        }
        .rests-box {
            text-align: center;
            margin-right: 15px;
            display: flex;
            justify-content: center;
            .auth-source-list {
                width: 45px;
                height: 45px;
                // background: #FFFFFF;
                border-radius: 50%;
                margin: 0 13px 15px;
                cursor: pointer;
                .rests-pic {
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                    transition: transform 0.5s;
                }
            }
            .auth-source-list:hover .rests-pic {
                transform: scale(1.1);
                box-shadow: 0 6px 12px 0 rgb(42 154 243 / 35%)
            }
        }
    }
    .login-index {
        height: 100%;
        .no-app {
            display: inline-block;
            position: relative;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            img {
                margin-left: 120px;
            }
            .no-title {
                text-align: center;
                margin-top: 50px;
                font-size: 16px;
            }
        }
    }
    .spin-box ::v-deep {
        height: 100%;
        .ant-spin-container {
            height: 100%;
        }
    }
    .phone-code ::v-deep {
        .ant-form-item-children {
            display: flex;
        }
    }
    .code-btn ::v-deep {
        .ant-input {
            height: 46px;
            border-radius: 10px 0 0 10px;
            padding-left: 20px;
            font-size: 16px;
            border-right: 0;
            // background-color: #f5f5f5;
            // border: none;
        }
        .ant-input:hover,.ant-input:focus {
            border-right: 1px solid  #40a9ff !important;
        }
        .ant-input:focus {
            box-shadow:none;
        }
        .ant-input-group-addon {
            border-radius: 0 10px 10px 0;
            background-color: #fff;
            // border: none;
        }
        .code-text {
            // border-radius: 0 25px 25px 0;
            padding: 0 30px;
            font-size: 16px;
            text-decoration: none;
            border: 0 !important;
        }
        .code-text:hover,.code-text:focus {
            border: 0;
            outline: none;
        }
    }
    .code-pwd ::v-deep {
        .ant-input {
            height: 46px;
            border-radius:10px;
            /*padding-left: 20px;*/
            font-size: 16px;
            /*border-right: 0;*/
            // background-color: #f5f5f5;
            // border: none;
        }
        /*.ant-input:hover,.ant-input:focus {*/
        /*    border-right: 1px solid  #40a9ff !important;*/
        /*}*/
        /*.ant-input:focus {*/
        /*    box-shadow:none;*/
        /*}*/

        .code-text {
            // border-radius: 0 25px 25px 0;
            padding: 0 30px;
            font-size: 16px;
            text-decoration: none;
            border: 0 !important;
        }


    }

    .code-box_bg{
        text-align: center;
        position: absolute;
        width:252px !important;
        top:30px !important;
        left: 43px !important;
        // border: 1px dashed #ccc;
    }
    @media screen and (min-width: 320px) and (max-width: 480px){
        .login-box .box .right-box{
            padding: 10px 13px 10px 10px;
        }
        .login-box .more-title{
            font-size: 14px;
            margin: 10px -10px 20px;
            span{
                margin:0 3px;
            }
        }
        .go-box{
            margin-right:1px;
        }
        ::v-deep{
            .theme--light.v-input input{
                font-size: 14px;
            }
        }
        .login-box .more-box img{
            margin: 0 8px 20px;
        }
        .more-box .img_box .img_shadow{
            display: block !important;
        }
        .more-box .img_box .img_shadow_none{
            left: 0px !important;
            top: 0px !important;
        }
    }
  .login-box-style {
    min-width: 400px;
    max-width: 460px;
    min-height: 340px;
    background-color: #ffffff;
    border-radius: 10px;
    padding-bottom: 40px !important;
  }
</style>
